import React, {useEffect} from 'react'
import {toGmapQuery} from '../../../../components/helpers'
import {KTIcon, KTSVG} from '../../../../_metronic/helpers'
import {ModeleClient} from '../../../../components/Models'
import {Tooltip} from 'react-tooltip'
import {ClientShowPage} from '../../shop/clients/pages/ClientShowPage'

type Props = {
  clientData: ModeleClient | null
  demandeId: any | undefined
  otherData: any
  loadingCLientInfo: boolean | null | undefined
  isProspect: boolean | null | undefined
  displaySuggestion?: boolean | null | undefined
  clientAdresses: any | undefined
  contactedBy: any | null | undefined
  fromModal?: boolean | null | undefined
  showMoreInfoCreate?: boolean | null | undefined
  isEdit?: boolean | null | undefined
  changeClientOnShop?: boolean | null | undefined
  setIsEdit?: any
  fromListDemande?: boolean
  clientDemandeStatus?: string | null | undefined
  setClientAdresseEdit?: any
  refetchClientData?: any
  setRefetchClientData?: any
}

const ClientInfos = (
  {
    clientData,
    demandeId,
    otherData,
    isProspect,
    clientAdresses,
    displaySuggestion = true,
    contactedBy,
    fromModal = false,
    isEdit = false,
    changeClientOnShop = false,
    setIsEdit,
    fromListDemande = false,
    clientDemandeStatus = '',
    setClientAdresseEdit,
    refetchClientData,
    setRefetchClientData
  }: Props) => {

  const infoDisplay = () => {
    const verificationIsEdit = window?.location?.href?.includes('edit')
    const displayButton = (
      (clientDemandeStatus !== null && clientDemandeStatus !== undefined)
      && ["NOUVE", "ASSIG", "MODIF", ""].includes(clientDemandeStatus)
    )

    return (
      <>
        <div className={`${displaySuggestion && 'p-5'} ${!fromModal && 'pb-0'} rounded-1`}>
          <div className='w-100'>
            <div
              className={`d-flex justify-content-between ${
                !displaySuggestion && 'flex-row p-8 pb-3'
              }`}
            >
              <div>
                <div className='d-flex align-items-center gap-2'>
                  {/*<a href={`/vente/clients/${clientData?.id}/afficher`} target='_blank'>*/}
                  <p
                    className={`text-gray-800 ${
                      !fromListDemande && displaySuggestion ? 'text-hover-primary' : ''
                    } fs-2 fw-bolder mb-0`}
                    data-bs-target={`${
                      !fromListDemande && displaySuggestion ? '#modal_client_show_page' : ''
                    }`}
                    data-bs-toggle={`${!fromListDemande && displaySuggestion ? 'modal' : ''}`}
                    data-bs-dismiss={`${!fromListDemande && displaySuggestion ? 'modal' : ''}`}
                    style={{cursor: !fromListDemande && displaySuggestion ? 'pointer' : 'default'}}
                  >
                    {clientData?.professionnel ? (
                      <>{clientData?.nomSociete}</>
                    ) : (
                      <>
                        {clientData?.nom} {clientData?.prenom}
                      </>
                    )}
                  </p>
                  {/*</a>*/}
                  {'- ' + contactedBy?.email == '' ? clientData?.email : contactedBy?.email}
                  {displaySuggestion && (
                    <>
                      {isProspect ? (
                        <span className='px-4 mx-3 badge badge-prosp fw-bolder'>PROSPECT</span>
                      ) : (
                        <span className='px-4 badge badge-light-primary fw-bolder'>CLIENT</span>
                      )}
                      {clientData?.professionnel ? (
                        <span className='badge badge-prof fw-bolder px-4 mx-3'>Professionnel</span>
                      ) : (
                        <span className='badge badge-part fw-bolder px-4 mx-3'>Particulier</span>
                      )}
                    </>
                  )}
                  <div>
                    <span>
                      {[
                        clientData?.codeClientAIndus && 'Industrie',
                        clientData?.codeClientAMoto && 'Motos',
                        clientData?.codeClientAAuto && 'Autos',
                      ]
                        .filter(Boolean)
                        .map((item, index) => (
                          <span key={index} className='badge bg-primary me-2'>
                            {item}
                          </span>
                        ))}
                    </span>
                  </div>
                  {displaySuggestion && demandeId && (
                    <span
                      className='me-2'
                      data-tooltip-id='tooltip'
                      data-tooltip-content="Voir l'historique du client"
                      data-tooltip-place='right'
                      onClick={() => {
                        if (!clientData?.id) return
                        sessionStorage.setItem('idClient', JSON.stringify(clientData?.id))
                        window.open('/demandes/liste', '_blank')
                      }}
                      style={{cursor: 'pointer'}}
                    >
                      <i className='bi bi-clock-history'></i>
                    </span>
                  )}
                </div>
                {/* Numéro de téléphone - email*/}
                {clientData?.email && (
                  <div className='d-flex flex-wrap fw-bold mb-2 pe-2 align-items-center gap-3'>
                    <div className='d-flex'>
                      <i className='bi bi-envelope-fill fs-6 me-3'></i>
                      <div className='text-gray-400 text-hover-primary'>
                        <a
                          href={`mailto:${clientData.email}`}
                          className='text-gray-400 text-hover-primary'
                        >
                          {clientData.email}
                        </a>
                      </div>
                    </div>

                    {!displaySuggestion && (
                      <div className='d-flex flex-wrap fw-bold fs-6 ms-5'>
                        {clientData?.pays?.nom && (
                          <>
                            <KTIcon iconName='geolocation' className='fs-4 me-3'/>
                            <a
                              href={`https://www.google.com/maps/search/query=${toGmapQuery(
                                clientData?.pays?.nom +
                                ' ' +
                                clientData?.codePostal +
                                ' ' +
                                clientData?.ville
                              )}`}
                              target={'_blank'}
                              className='d-flex align-items-center text-gray-400 text-hover-primary'
                            >
                              {clientData?.pays?.nom}, {clientData?.codePostal} {clientData?.ville}
                            </a>
                          </>
                        )}
                      </div>
                    )}
                    <div>
                      <span
                        className={`badge ${
                          clientData?.isActif ? 'badge-light-success' : 'badge-light-secondary'
                        }`}
                      >
                        {clientData?.isActif ? 'Actif' : 'Non actif'}
                      </span>
                    </div>
                  </div>
                )}
                <div className='d-flex flex-wrap fw-bold mb-2 pe-2 gap-3'>
                  {clientData?.telephone && (
                    <div className='d-flex'>
                      <i className='bi bi-telephone-fill fs-6 me-3'></i>
                      <div className='text-gray-400 text-hover-primary'>
                        <a
                          href={`tel:${clientData.telephone}`}
                          className='text-gray-400 text-hover-primary'
                        >
                          {clientData.telephone}
                        </a>
                      </div>
                    </div>
                  )}
                  {clientData?.mobile && (
                    <div className='d-flex'>
                      <i className='bi bi-telephone fs-6 me-3'></i>
                      <div className='text-gray-400 text-hover-primary'>
                        <a
                          href={`tel:${clientData.mobile}`}
                          className='text-gray-400 text-hover-primary'
                        >
                          {clientData.mobile}
                        </a>
                      </div>
                    </div>
                  )}
                </div>
                {/* Numéro de téléphone - email*/}
                {clientData?.pays != null && (
                  <>
                    <div className='d-flex flex-wrap fw-bold fs-6 pe-2'>
                      <KTIcon iconName='geolocation' className='fs-4 me-3'/>
                      <a
                        href={`https://www.google.com/maps/search/query=${toGmapQuery(
                          clientData?.pays?.nom +
                          ' ' +
                          clientData?.codePostal +
                          ' ' +
                          clientData?.ville
                        )}`}
                        target={'_blank'}
                        className='d-flex align-items-center text-gray-400 text-hover-primary me-5'
                      >
                        {clientData?.pays?.nom}, {clientData?.codePostal} {clientData?.ville}
                      </a>
                    </div>
                  </>
                )}
              </div>

              {clientData?.message && (
                <div className='w-400px pb-3'>
                  <div className='d-flex justify-content-between'>
                    <div>
                      <p className='text-gray-400 text-hover-primary'>Message :</p>
                      <p className='text-gray-400 text-hover-primary'>Bloquant :</p>
                      <div className='bg-secondary text-center p-1' style={{borderRadius: '12px'}}>
                        {clientData?.messageBloquant ? 'Oui' : 'Non'}
                      </div>
                    </div>
                    <div
                      className='w-300px bg-secondary'
                      style={{padding: '10px', borderRadius: '12px', whiteSpace: 'pre-wrap'}}
                    >
                      <p>{clientData?.message}</p>
                    </div>
                  </div>
                </div>
              )}

              {/*debut affichage de modification client*/}
              {(isEdit && displayButton) && (
                <div className='w-400px text-end'>
                  {(verificationIsEdit) && (
                    <button
                      className={'btn btn-sm btn-light-success me-2'}
                      data-bs-target='#choixEquipeModal'
                      data-bs-toggle='modal'
                      type='button'
                    >
                      Modification équipe
                    </button>
                  )}
                  <button
                    className={'btn btn-sm btn-light-primary'}
                    data-bs-target='#exampleModalToggle'
                    data-bs-toggle='modal'
                    type='button'
                  >
                    Changer Client
                  </button>
                </div>
              )}
              {/*affichage modification client panier*/}
              {(changeClientOnShop && displayButton) && (
                <div>
                  {/*<span className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'></span>*/}
                  <button
                    className={'btn btn-sm btn-light-info'}
                    onClick={() => setIsEdit(true)}
                    data-bs-target='#exampleModalToggle'
                    data-bs-toggle='modal'
                    data-bs-dismiss='modal'
                    type='button'
                  >
                    Changer Client
                  </button>
                </div>
              )}
              {/*fin affichage de modification client*/}
              {!displaySuggestion && (
                <span className='fs-3'>
                  Demande<span className='text-primary fs-3'> #{demandeId}</span>
                </span>
              )}
            </div>
          </div>
        </div>
        <Tooltip id='tooltip'/>

        {/*modal fiche client */}
        {clientData?.id && (
          <div className='modal fade' tabIndex={-1} id='modal_client_show_page'>
            <div className='modal-dialog modal-xl'>
              <div className='modal-content'>
                <div className='modal-header'>
                  <h5 className='modal-title'>Fiche client</h5>
                  <div
                    className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                    data-bs-dismiss='modal'
                    aria-label='Close'
                  >
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr061.svg'
                      className='svg-icon svg-icon-2x'
                    />
                  </div>
                </div>
                <div className='modal-body'>
                  <ClientShowPage
                    dataClient={clientData}
                    dataOther={otherData}
                    setClientAdresseEdit={setClientAdresseEdit}
                    refetchClientData={refetchClientData}
                    setRefetchClientData={setRefetchClientData}
                  />
                </div>
                <div className='modal-footer justify-content-end'>
                  <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                    Fermer
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    )
  }

  return <>{infoDisplay()}</>
}

export default ClientInfos
